/**
 * @stable
 */
export enum AnimateOverlayFrom {
    Left = 'left',
    Bottom = 'bottom',
}

/**
 * @stable
 */
export interface AnimatedOverlayStates {
    initial: string;
    off: string;
    on: string;
}
